/* eslint-disable no-mixed-operators */
/* eslint-disable prefer-exponentiation-operator */
/* eslint-disable no-restricted-properties */
/* eslint-disable max-len */
/**
 * 获得贷款计算器基础数据
 */
export function getInitData(price, rate) {
  return {
    firstPc: 20,
    firstPcType: 1,
    rateVal: rate || 0.0654,
    loanYear: 20,
    payTime: 2,
    loanType: 1,
    total: price
  }
}

/**
 * 等额本息计算
 * 
 * @param {Number} loanAmount 贷款金额
 * @param {Number} payTimeValue 支付频率
 * @param {Object} data 其它数据
 * 
 * @return {Object}
 */
export function benxiCalc(loanAmount, payTimeValue, data) {
  const month = parseInt(data.loanYear, 10) * payTimeValue
  const monthlyInterestRate = parseFloat(data.rateVal) / payTimeValue
  const totalLoanAmount = parseFloat(loanAmount)

  // 每月月供额=〔贷款本金×月利率×(1＋月利率)＾还款月数〕÷〔(1＋月利率)＾还款月数-1〕
  const monthlyPayment = (totalLoanAmount * monthlyInterestRate * Math.pow((1 + monthlyInterestRate), month)) / (Math.pow((1 + monthlyInterestRate), month) - 1)

  // 总利息=还款月数×每月月供额-贷款本金
  const totalInterest = month * monthlyPayment - totalLoanAmount
  // 还款总额 总利息+贷款本金
  const totalRepayment = totalInterest + totalLoanAmount
  // 剩余还款金额
  let leftFund = totalInterest + totalLoanAmount
  
  // 每周期还款额
  const amountPerInstalment = data.loanType === 1 
    ? monthlyPayment 
    : (monthlyInterestRate * totalLoanAmount)

  // ===================================================
  // 计算每月还款
  const yearRepayments = [] // 年还款数据汇总
  let currentYear = new Date().getFullYear() // 当前年份
  let yearInterest = 0 // 每年还款利息
  let yearPrincipal = 0 // 每年还款本金
  const currentMonth = new Date().getMonth() + 1

  // 如果当前是12月，则从下一年1月开始计算
  currentYear = currentMonth === 12 
    ? currentYear + 1 
    : currentYear

  for (let i = 1; i <= month; i++) {
    // 每月应还利息=贷款本金×月利率×〔(1+月利率)^还款月数-(1+月利率)^(还款周期序号-1)〕÷〔(1+月利率)^还款月数-1〕
    const monthlyInterest = totalLoanAmount * monthlyInterestRate * (Math.pow((1 + monthlyInterestRate), month) - Math.pow((1 + monthlyInterestRate), i - 1)) / (Math.pow((1 + monthlyInterestRate), month) - 1)

    // 每月应还本金=贷款本金×月利率×(1+月利率)^(还款周期序号-1)÷〔(1+月利率)^还款月数-1〕
    const monthlyPrincipal = totalLoanAmount * monthlyInterestRate * Math.pow((1 + monthlyInterestRate), i - 1) / (Math.pow((1 + monthlyInterestRate), month) - 1)

    // 年本金与利息累加值
    yearInterest += monthlyInterest
    yearPrincipal += monthlyPrincipal

    // 剩余还款
    leftFund -= (monthlyInterest + monthlyPrincipal)

    // 当前第第几个还款周期
    let currentPaytime = Math.floor(currentMonth * payTimeValue / 12) + i - payTimeValue * Math.floor(i / payTimeValue)
    currentPaytime = currentPaytime > payTimeValue 
      ? currentPaytime - payTimeValue
      : currentPaytime

    if(currentPaytime === payTimeValue || i === month) {
      yearRepayments.push({
        currentYear,
        yearInterest,
        yearPrincipal,
        leftFund: leftFund < 0 ? 0 : leftFund
      })
      
      yearInterest = 0
      yearPrincipal = 0
      currentYear++
    }
  }
  
  return {
    monthlyPayment,
    totalInterest,
    totalRepayment,
    yearRepayments,
    totalLoanAmount,
    year: data.loanYear,
    amountPerInstalment
  }
}

/**
 * 获取计算后的数据
 */
export function getCalculatedData(data) {
  const { total, firstPcType, firstPc, payTime } = data
  
  // 除了首付，剩余的贷款金额
  const floatTotal = parseFloat(total)
  const loanAmount = firstPcType === 1
    ? floatTotal * (100 - firstPc) / 100
    : floatTotal - firstPc
  
  // 还款频率类型对应的值
  const payTimeDivider = { 2: 12, 3: 26, 4: 52 }
  const payTimeValue = payTimeDivider[payTime]

  return benxiCalc(loanAmount, payTimeValue, data)
}

function clearPrice(p) {
  const n = String(p).replace(/[\\$,]/g, '')
  return /\d+/.test(n) 
    ? (parseFloat(n) || undefined) // 过滤 NaN
    : undefined
}

/**
 * 获取房源价格
 */
export function getPrice(house) {
  let price = clearPrice(house?.priceBold)
  if(price !== undefined) {
    return price
  }

  price = clearPrice(house?.avm?.avm_value)
  if(price !== undefined) {
    return price
  }
  
  price = clearPrice(house?.publicRecords?.rateable_value)
  if(price !== undefined) {
    return price
  }

  return 500000
}

export function getPriceBold(house) {
  return clearPrice(house?.priceBold)
}

/**
 * 获取还款频率名称
 */
export function getPaytimeLabel(payTime, th) {
  const tmp = {
    2: th('perMonth'),
    3: th('perTwoWeek'),
    4: th('perWeek')
  }
  return tmp[payTime]
}

/**
 * 获取基础数据
 */
export function getBaseOptions(th) {
  const firstPcTypeOptions = [
    { label: th('percentage'), value: 1 },
    { label: th('amount'), value: 2 },
  ]

  const loanTypeOptions = [
    { label: th('principalInterest'), value: 1 },
    { label: th('jsutInterest'), value: 2 },
  ]

  const payTimeOptions = [
    { label: th('perMonth'), value: 2 },
    { label: th('perTwoWeek'), value: 3 },
    { label: th('perWeek'), value: 4 },
  ]

  return {
    firstPcTypeOptions,
    loanTypeOptions,
    payTimeOptions,
  }
}
